export default "__VITE_ASSET__a25b21c3__"